// import { testLayout } from '../model';
import Vue from 'vue';

const state = {
  gridLayout: {},
  gridOptions: {
    columns: 12,
    rowHeight: 50,
    margins: [10, 0],
    isDraggable: true,
    isResizable: true
  },
  columnWidth: 10
}

const getters = {
  /* eslint-disable no-shadow */
  currentGridLayout: state => state.gridLayout,
  gridOptions: state => state.gridOptions,
  columnWidth: state => state.columnWidth,
  /* eslint-enable no-shadow */
  getFacetById: (state) => (id) => {
    return state.gridLayout.find(facet => facet.i === id);
  }
}

const actions = {
  /**
   * updateGridOptions store action
   * @param {Object} newGridOptions
   * @since 0.1.25
   */
  updateGridOptions ({ commit }, newGridOptions) {
    commit('updateGridOptions', newGridOptions);
  },
  updateFacet ({ commit }, facet) {
    commit('updateFacetInLayout', facet);
  },
  /**
   * @name removeFacet
   * @description Removes the facet from the store via the `removeFacetFromLayout` mutation
   * @param {Number} facetId - The Facet ID used to find this facet to remove.
   */
  removeFacet ({ commit }, facetId) {
    commit('removeFacetFromLayout', facetId);
  },
  updateFacetOptions ({ commit }, payload) {
    commit('updateFacetOptionsMutation', payload);
  },
  updateColumnWidth ({ commit }, width) {
    commit('updateColumnWidthMutation', width);
  },
  newLayout ({commit}, layout) {
    commit('updateLayout', layout);
  },
  newSchema ({commit}, payload) {
    commit('UPDATE_SCHEMA', payload);
  }
}

const mutations = {
  /**
   * updateGridOptions
   * @since 0.1.25
   * @param {Object} newGridOptions
   */
  updateGridOptions ({ gridLayout }, newGridOptions) {
    state.gridOptions = newGridOptions;
  },
  addLayout ({ gridLayout }, text) {
    gridLayout.push({
      text,
      completed: false
    });
  },
  updateLayout ({ gridLayout }, newLayout) {
    state.gridLayout = newLayout;
  },
  addFacetToLayout ({ gridLayout }, facetData) {
    gridLayout.push(facetData);
  },
  updateFacetInLayout ({ gridLayout }, facetData) {
    /* eslint-disable prefer-arrow-callback, no-param-reassign */
    gridLayout.forEach(function forEachFacet (facet, index) {
      if (parseInt(facet.id) === parseInt(facetData.id)) {
        Vue.set(state.gridLayout[index], facetData);
      }
    });
    /* eslint-enable prefer-arrow-callback, no-param-reassign */
  },
  updateFacetOptionsMutation ({ gridLayout }, payload) {
    let newFacet;
    let facetId;

    gridLayout.forEach(function forEachFacet (facet, index) {
      if (facet.id === payload.facetId) {
        newFacet = facet;
        facetId = index;
        newFacet.model = payload.facetModel;
      }
    });
    Vue.set(state.gridLayout[facetId], newFacet);
  },
  /**
   * @name removeFacetFromLayout
   * @description
   *  This will take the incoming facetId; find that facet; and remove it.
   * @todo resize the facets in the grid upon deletion.
   * @param {Object} gridLayout - the state.gridLayout object
   * @param {Number} facetId - the facetId prop
   * @since 0.1.11
   */
  removeFacetFromLayout ({ gridLayout }, facetId) {
    const index = gridLayout.findIndex(facet => facet.id === facetId);
    state.gridLayout.splice(index, 1);

    //  - This will begin to auto-resize the facets on deletion.
    //  const facetToDie = gridLayout[index];
    //  const temp = state.gridLayout.findIndex(facet => facet.x === (facetToDie.x + facetToDie.w));
    //  console.log('temp: ', temp);
    //  state.gridLayout[temp].w += facetToDie.w;
    //  state.gridLayout[temp].x = facetToDie.x;
  },
  updateColumnWidthMutation ({ gridLayout }, width) {
    state.columnWidth = width;
  },
  /**
   * UPDATE_SCHEMA
   * @param {Object} gridLayout - The main gridLayout object
   * @param {Object} payload - consists of id and schema
   * @since 1.2.0
   */
  UPDATE_SCHEMA ({ gridLayout }, payload) {
    let id = payload.id;
    let schema = payload.schema;
    const newFacet = gridLayout.filter(facet => facet.id === parseInt(id));
    console.log('UPDATE_SCHEMA: ', newFacet);
    newFacet[0].schema = schema;

    state.gridLayout.forEach(function forEachFacet (facet, index) {
      if (facet.id === parseInt(id)) {
        // console.log('Old and new schema: ', gridLayout[index].schema, schema);
        // gridLayout[index].schema = schema;
        Vue.set(state.gridLayout, index, newFacet[0]);
      }
    });
  }
}

/**
 * The namespaced true aspect forces any calls to this store module to be prefixed
 */
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/layouts.js